import StyledButton from "../StyledButton";
import styles from "./style.module.scss";

export type TButtonDetail = {
    label: string;
    action?: (arg?: any) => void;
    type?: "button" | "submit";
};

export type TModalActionButton = {
    cancel: TButtonDetail;
    confirm: TButtonDetail;
};
interface IModalActionButtons {
    buttonsDetails: TModalActionButton;
    loading?: boolean;
    disabled?: boolean;
}

/**
 * Buttons at bottom of simple modal with Cancel/Confirm actions.
 */
const ModalActionButtons = ({ buttonsDetails, loading, disabled }: IModalActionButtons) => {
    return (
        <div className={styles["modal-buttons"]}>
            <StyledButton buttonType="outlined" onClick={buttonsDetails.cancel.action}>
                {buttonsDetails.cancel.label}
            </StyledButton>
            <StyledButton
                buttonType="primary"
                onClick={buttonsDetails.confirm.action}
                loading={loading}
                disabled={disabled}
                type={buttonsDetails.confirm.type}
            >
                {buttonsDetails.confirm.label}
            </StyledButton>
        </div>
    );
};

export default ModalActionButtons;
